import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { display, buildEndpointHost, mapValues } from '@datadog/browser-core';
var REMOTE_CONFIGURATION_VERSION = 'v1';
var SUPPORTED_FIELDS = ['applicationId', 'service', 'env', 'version', 'sessionSampleRate', 'sessionReplaySampleRate', 'defaultPrivacyLevel', 'enablePrivacyForActionName', 'traceSampleRate', 'trackSessionAcrossSubdomains', 'allowedTracingUrls', 'allowedTrackingOrigins'];
export function fetchAndApplyRemoteConfiguration(_x) {
  return _fetchAndApplyRemoteConfiguration.apply(this, arguments);
}
function _fetchAndApplyRemoteConfiguration() {
  _fetchAndApplyRemoteConfiguration = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(initConfiguration) {
    var fetchResult;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return fetchRemoteConfiguration(initConfiguration);
        case 1:
          fetchResult = _context.sent;
          if (fetchResult.ok) {
            _context.next = 2;
            break;
          }
          display.error(fetchResult.error);
          return _context.abrupt("return");
        case 2:
          return _context.abrupt("return", applyRemoteConfiguration(initConfiguration, fetchResult.value));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchAndApplyRemoteConfiguration.apply(this, arguments);
}
export function applyRemoteConfiguration(initConfiguration, rumRemoteConfiguration) {
  // intents:
  // - explicitly set each supported field to limit risk in case an attacker can create configurations
  // - check the existence in the remote config to avoid clearing a provided init field
  var appliedConfiguration = _objectSpread({}, initConfiguration);
  SUPPORTED_FIELDS.forEach(function (option) {
    if (option in rumRemoteConfiguration) {
      appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
    }
  });
  return appliedConfiguration;
}
function resolveConfigurationProperty(property) {
  if (Array.isArray(property)) {
    return property.map(resolveConfigurationProperty);
  }
  if (isObject(property)) {
    if (isSerializedOption(property)) {
      var type = property.rcSerializedType;
      switch (type) {
        case 'string':
          return property.value;
        case 'regex':
          return resolveRegex(property.value);
        default:
          display.error("Unsupported remote configuration: \"rcSerializedType\": \"".concat(type, "\""));
          return;
      }
    }
    return mapValues(property, resolveConfigurationProperty);
  }
  return property;
}
function isObject(property) {
  return typeof property === 'object' && property !== null;
}
function isSerializedOption(value) {
  return 'rcSerializedType' in value;
}
function resolveRegex(pattern) {
  try {
    return new RegExp(pattern);
  } catch (_a) {
    display.error("Invalid regex in the remote configuration: '".concat(pattern, "'"));
  }
}
export function fetchRemoteConfiguration(_x2) {
  return _fetchRemoteConfiguration.apply(this, arguments);
}
function _fetchRemoteConfiguration() {
  _fetchRemoteConfiguration = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(configuration) {
    var response, remoteConfiguration, _t;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 1;
          return fetch(buildEndpoint(configuration));
        case 1:
          response = _context2.sent;
          _context2.next = 3;
          break;
        case 2:
          _context2.prev = 2;
          _t = _context2["catch"](0);
          response = undefined;
        case 3:
          if (!(!response || !response.ok)) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", {
            ok: false,
            error: new Error('Error fetching the remote configuration.')
          });
        case 4:
          _context2.next = 5;
          return response.json();
        case 5:
          remoteConfiguration = _context2.sent;
          if (!remoteConfiguration.rum) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", {
            ok: true,
            value: remoteConfiguration.rum
          });
        case 6:
          return _context2.abrupt("return", {
            ok: false,
            error: new Error('No remote configuration for RUM.')
          });
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return _fetchRemoteConfiguration.apply(this, arguments);
}
export function buildEndpoint(configuration) {
  if (configuration.remoteConfigurationProxy) {
    return configuration.remoteConfigurationProxy;
  }
  return "https://sdk-configuration.".concat(buildEndpointHost('rum', configuration), "/").concat(REMOTE_CONFIGURATION_VERSION, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json");
}